import { provenance as provenanceContracts } from '@dha-nexus/shared';

const NORMALIZERS = {
  ai: provenanceContracts.normalizeLegacyAiRun,
  artifact: provenanceContracts.normalizeLegacyArtifact,
  connector: provenanceContracts.normalizeLegacyConnectorResult,
};

export function normalizedProvenance(value, kind) {
  const normalize = NORMALIZERS[kind];
  if (!normalize) throw new TypeError(`Unsupported provenance kind: ${kind}`);
  return normalize(value);
}

export function ProvenanceBadge({ value, kind, className = '' }) {
  const normalized = normalizedProvenance(value, kind);
  const badge = provenanceContracts.badgeFor(normalized);

  return (
    <span
      className={`chip outline sm ${className}`.trim()}
      title={badge.tooltip}
      data-provenance-kind={kind}
    >
      {badge.label}
    </span>
  );
}
